import { render, staticRenderFns } from "./JdsTableFooterCutout.vue?vue&type=template&id=6603de2e&scoped=true&"
import script from "./JdsTableFooterCutout.vue?vue&type=script&lang=ts&"
export * from "./JdsTableFooterCutout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6603de2e",
  null
  
)

export default component.exports